import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_Expiration_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_Expiration_FIN.interface';
import { Data_Check, Filter_Check_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-document-expire-fin',
    templateUrl: './document-expire-fin.component.html',
    styleUrls: ['./document-expire-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/FlowMGlobal.css'],
    standalone: false
})
export class DocumentExpireFINComponent implements OnInit {

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== SEARCH ==================+\\
  public Filter_FlowM: string = '';

  //+================== VARIABLES GLOBAL FILES FLOW M FIN ==================+\\
  public ALL_EXPIRED_FIN: Data_Expiration_FIN[] = [];
  public Copy_ALL_EXPIRED_FIN: Data_Expiration_FIN[] = [];
  public SelectedALL_EXPIRED_FIN: Data_Expiration_FIN[] = [];

  public LoadPage: boolean = false;
  public IsExpired: boolean = false;

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersFM: Headers_CCP[] = [];

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
  };


  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-slash', Description: 'El usuario no fue requerido en el flujo' },
    { Icon: 'fa-user-pen', Description: 'El Proceso está siendo revisado' },
    { Icon: 'fa-user-clock', Description: 'El proceso está pendiente de pasar al siguiente nivel de aprobación' },
    { Icon: 'fa-user-check', Description: 'El Proceso ha sido revisado y aprobado' },
    { Icon: 'fa-user-xmark', Description: 'El Proceso ha sido revisado y rechazado' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido aprobado por un administrador' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido rechazado por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del aprobador, El Proceso puede ser muy antiguo' }
  ];

  //+================== VARIABLES FOR ICONS ==================+\\
  public StatusExpired = [
    { StatusExpired: 1, Description: 'El Procedimiento se encuentra con una fecha de vencimiento adecuado.' },
    { StatusExpired: 2, Description: 'El Procedimiento se encuentra próximo a vencer, le faltan 3 meses.' },
    { StatusExpired: 3, Description: 'El Procedimiento se encuentra vencido.' },
  ];


  //-========================= SERVICES =========================-\\

  private Service_FIN = inject(LibraryFINService);
  private router = inject(Router);

  constructor() {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTION FOR LOAD COMPONENT FLOW MONITORING FIN =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      const resHeaders: any = await firstValueFrom(this.Service_FIN.Get_Headers('fin'));
      if (resHeaders.success) {
        const validKeys = ['NAMFI', 'CODEF', 'DESCR', 'NOREV', 'DACRE', 'DAEXP', 'STATU', 'TIMER'];
        this.HeadersFM = resHeaders.operation.filter((h: any) =>
          h.Visible && (validKeys.includes(h.Key_Header) || h.Key_Header.startsWith('APPR'))
        );
        // Always include ROUTE at the beginning
        this.HeadersFM.unshift({ ID: 0, Name: 'Ruta', Position: 0, Visible: true, Key_Header: 'ROUTE' });
      }

      const ResFlow_M_FIN: any = await firstValueFrom(this.Service_FIN.Procedures_Due_To_Expire_FIN());

      if (ResFlow_M_FIN.success) {
        this.ALL_EXPIRED_FIN = ResFlow_M_FIN.operation;
        this.Copy_ALL_EXPIRED_FIN = ResFlow_M_FIN.operation;
      }

      this.LoadPage = true;
      Loader.classList.remove('active');

      this.Generate_Filters();

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar estatus de Proceso, recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;

    }


  }

  //&===================== END FUNCTION FOR LOAD COMPONENT FLOW MONITORING FIN =====================&\\


  //&===================== FUNCTIONS FOR GENERAL FLOW MONITORING FIN =====================&\\

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp_Expiration(CloseOrOpen: boolean): void {
    const ModalIconsHelp_Expiration = document.getElementById('ModalIconsHelp_Expiration') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp_Expiration.classList.add('active') : ModalIconsHelp_Expiration.classList.remove('active');
  }

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR STATUS OF FIN ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE FIN IN FIN LIBRARY FILE MANAGER ================-\\
  public SeeFINLibrary(URL: string): void {

    const RouteEncode: string = encodeURIComponent(URL);

    this.router.navigate([`Dashboard/FIN/FMLibraryFIN/${RouteEncode}`]);
  }

  //-================ FUNCTION GREETING ================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || '';
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================ FUNCTION FOR ASSIGNED STATUS IN FIN OF DATE EXPIRED ================-\\
  public Expiry_Status(Date_Expiration: Date): string {

    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 90) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 90) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  //-================== FUNCTION FOR CUT CODE ==================-\\
  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  //-================== FUNCTION FOR SEE CODE COMPLETE ==================-\\
  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  //-================ FUNCTION CUT DESCRIPTION ================-\\
  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 32 ? Purpose.slice(0, 32) + '...' : Purpose;
  }

  //-================ FUNCTION SEE DESCRIPTION COMPLETE ================-\\
  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  public Get_Dynamic_Approver_Name(FlowItem: any, key: string): string {
    return FlowItem[`${key}_Name`] || 'No fue requerido';
  }

  public Get_Dynamic_Approver_Status(FlowItem: any, key: string): number {
    return FlowItem[`StatusTask${key.replace('APPR', '')}`] || 0;
  }

  public Get_Time_Remaining(Days: number): string {

    const Current_Date: Date = moment().toDate();

    return Days >= 0 ? this.Get_Time_Positive(Current_Date, Days) : this.Get_Time_Negative(Current_Date, Days);

  }

  private Get_Time_Positive(Current_Date: Date, Days: number): string {

    const Date_Add: Date = moment(Current_Date).add(Days, 'd').toDate();

    const Full_Months: number = moment(Date_Add).diff(Current_Date, 'M');

    const Date_less_Months: Date = moment(Date_Add).subtract(Full_Months, 'M').toDate();

    const Days_Remaining: number = moment(Date_less_Months).diff(Current_Date, 'd');

    return Full_Months > 0 ? `Quedan ${Full_Months} meses y ${Days_Remaining} días antes de que venza` : `Quedan ${Days_Remaining} días antes de que venza`

  }

  private Get_Time_Negative(Current_Date: Date, Days: number): string {

    Days = Days * -1;

    const Date_Add: Date = moment(Current_Date).add(Days, 'd').toDate();

    const Full_Years: number = moment(Date_Add).diff(Current_Date, 'y');
    const Date_less_Years: Date = moment(Date_Add).subtract(Full_Years, 'y').toDate();

    const Full_Months: number = moment(Date_less_Years).diff(Current_Date, 'M');
    const Date_less_Months: Date = moment(Date_less_Years).subtract(Full_Months, 'M').toDate();


    const Days_Remaining: number = moment(Date_less_Months).diff(Current_Date, 'd');

    if (Full_Years > 0) {
      return `venció hace ${Full_Years} años, ${Full_Months} meses y ${Days_Remaining} días.`
    }

    if (Full_Months > 0) {
      return `venció hace ${Full_Months} meses y ${Days_Remaining} días.`
    }

    return `venció hace ${Days_Remaining} días.`

  }

  //&===================== END FUNCTIONS FOR GENERAL FLOW MONITORING FIN =====================&\\


  //-===================== FUNCTION FOR FILTERS =====================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Contributor_Name: [],
    } as any;

    // Add dynamic approver arrays based on headers
    this.HeadersFM.forEach((h: any) => {
      if (h.Key_Header.startsWith('APPR')) {
        this.Filter_Global_Check[h.Key_Header] = [];
      }
    });

    for (const FIN of this.ALL_EXPIRED_FIN as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = moment(FIN.Date_Expiration).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Approver1_Name = { Value: FIN.Approver1_Name } as Data_Check;
      FIN.F_Approver2_Name = { Value: FIN.Approver2_Name } as Data_Check;
      FIN.F_Approver3_Name = { Value: FIN.Approver3_Name } as Data_Check;
      FIN.F_Approver4_Name = { Value: FIN.Approver4_Name } as Data_Check;
      FIN.F_Contributor_Name = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some(item => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some(item => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some(item => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

      // Populate dynamic approver filters
      this.HeadersFM.forEach((h: any) => {
        if (h.Key_Header.startsWith('APPR')) {
          const name = this.Get_Dynamic_Approver_Name(FIN, h.Key_Header);
          if (name && name !== 'No fue requerido') {
            const filterArray = this.Filter_Global_Check[h.Key_Header] as any[];
            if (filterArray && !filterArray.some((item: any) => item.Value === name)) {
              filterArray.push({ Value: name });
            }
          }
        }
      });

    }


  }
  //-===================== END FUNCTION FOR FILTERS =====================-\\
}
